import { useState, useEffect, useCallback, useRef } from "react";

const useCollapsible = (minHeight = 100) => {
  const [isCollapsible, setIsCollapsible] = useState(false);
  const [elementHeight, setElementHeight] = useState(0);
  const elementRef = useRef(null);

  const calculateHeight = useCallback(() => {
    if (elementRef.current) {
      const height = elementRef.current.scrollHeight;
      setElementHeight(height);
      setIsCollapsible(height > minHeight);
    }
  }, [minHeight]);

  useEffect(() => {
    calculateHeight();

    // Create ResizeObserver to watch for size changes
    const resizeObserver = new ResizeObserver(() => {
      calculateHeight();
    });

    if (elementRef.current) {
      resizeObserver.observe(elementRef.current);
    }

    // Cleanup
    return () => {
      resizeObserver.disconnect();
    };
  }, [calculateHeight]);

  // Recalculate when minHeight changes
  useEffect(() => {
    calculateHeight();
  }, [minHeight, calculateHeight]);

  return {
    ref: elementRef,
    isCollapsible,
    elementHeight,
    recalculate: calculateHeight,
  };
};

export default useCollapsible;
